import { use18n, useIns } from 'src/utils/v2_helper/common'
import { computed } from 'vue';

export function useConfig() {
  const { $t, locale } = use18n();
  const app = useIns();
  const lang = computed(() => (locale === 'id-ID' ? 'id' : 'en'))
  const Gopay = [{
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step1-${lang.value}.png`,
    text: $t('waiting.gopayStep1')
  },
  {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step2-${lang.value}.png`,
    text: $t('waiting.gopayStep2')
  },
  {
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step3.png',
    text: $t('waiting.gopayStep3')
  },
  {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step4-${lang.value}.png`,
    text: $t('waiting.gopayStep4')
  }]
  const OVO = [{
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/ovo-step1.png',
    text: $t('waiting.ovoStep1')
  },
  {
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/ovo-step2.png',
    text: $t('waiting.ovoStep2')
  },
  {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/ovo-step3-${lang.value}.png`,
    text: $t('waiting.ovoStep3')
  },
  {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/ovo-step4-${lang.value}.png`,
    text: $t('waiting.ovoStep4')
  }]

  const ShopeePay = [{
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step1-${lang.value}.png`,
    text: $t('waiting.shopeeStep1')
  }, {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step2-${lang.value}.png`,
    text: $t('waiting.shopeeStep2')
  }, {
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step3.png',
    text: $t('waiting.shopeeStep3')
  }, {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step4-${lang.value}.png`,
    text: $t('waiting.shopeeStep4')
  }]
  const Dana = [{
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step1-${lang.value}.png`,
    text: $t('waiting.danaStep1')
  }, {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step2-${lang.value}.png`,
    text: $t('waiting.danaStep2')
  }, {
    img: 'https://static.bakmigm.co.id/menu/BuyerWaitingTip/shopee-step3.png',
    text: $t('waiting.danaStep3')
  }, {
    img: `https://static.bakmigm.co.id/menu/BuyerWaitingTip/gopay-step4-${lang.value}.png`,
    text: $t('waiting.danaStep4')
  }]

  return { Gopay, OVO, ShopeePay, Dana }
}
